'use strict';

define('Utilities',[
        'angularUTF8Base64',
        'angularCookie',
        'ngMd5',
        'CookieFac',
        'LocalStorageFac',
        'StatePersistenceFac',
        'PreferencesCookieFac',
        'RaceMtpDisplay',
        'FavoriteCookieFac',
        'FeaturesHandlerSvc',
        'UserPropertiesSvc',
        'WagerProfileFac',
        'TvgHostsFac',
        'NewWindowGridFac',
        'AmountOptionsFac',
        'LocationUnreloadFac',
        'RaceTypeIDFilter',
        'MathAbsoluteValueFilter',
        'GetNestedPropertyValueFilter',
        'GetRelativeDayBasedOnGivenDateFilter',
        'RoundAmountFilter',
        'ReverseFilter',
        'PreventDefaultDir',
        'TVGCommon'
    ],
    function (
        angularUTF8Base64,
        angularCookie,
        ngMd5,
        CookieFac,
        LocalStorageFac,
        StatePersistenceFac,
        PreferencesCookieFac,
        RaceMtpDisplay,
        FavoriteCookieFac,
        FeaturesHandlerSvc,
        UserPropertiesSvc,
        WagerProfileFac,
        TvgHostsFac,
        NewWindowGridFac,
        AmountOptionsFac,
        LocationUnreloadFac,
        RaceTypeIDFilter,
        MathAbsoluteValueFilter,
        GetNestedPropertyValueFilter,
        GetRelativeDayBasedOnGivenDateFilter,
        RoundAmountFilter,
        ReverseFilter,
        PreventDefaultDir,
        TVGCommon //eslint-disable-line no-unused-vars
    ) {
        angular.module('TVG.Utilities', [
            'ipCookie',
            'TVGCommon',
            'TVG.Track'
        ])
            .value('THROTTLE_MILLISECONDS', null)
            .factory('RaceMtpDisplay', RaceMtpDisplay)
            .factory('CookieFac', CookieFac)
            .factory('LocalStorageFac', LocalStorageFac)
            .factory('StatePersistenceFac', StatePersistenceFac)
            .factory('PreferencesCookieFac', PreferencesCookieFac)
            .factory('FavoriteCookieFac', FavoriteCookieFac)
            .factory('WagerProfileFac', WagerProfileFac)
            .service('FeaturesHandlerSvc', FeaturesHandlerSvc)
            .service('UserPropertiesSvc', UserPropertiesSvc)
            .factory('TvgHostsFac', TvgHostsFac)
            .factory('AmountOptionsFac', AmountOptionsFac)
            .factory('LocationUnreloadFac', LocationUnreloadFac)
            .factory('NewWindowGridFac', NewWindowGridFac)
            .filter('roundAmount', RoundAmountFilter)
            .filter('RaceTypeIDFilter', RaceTypeIDFilter)
            .filter('MathAbsoluteValueFilter', MathAbsoluteValueFilter)
            .filter('reverse',ReverseFilter)
            .directive('preventDefault', PreventDefaultDir)
            .directive('appTitle', function () {
                return {
                    restrict: 'E',
                    replace: true,
                    template: '<title>{{appTitle}}</title>',
                    scope: true
                };
            })
            .directive('removeClass', function () {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        element.removeClass(attrs.removeClass);
                    }
                };
            })
            .filter('trust', function ($sce) {
                return $sce.trustAsHtml;
            })
            .filter('truncate', function () {
                return function (text, length, end) {
                    if (isNaN(length))
                        length = 10;

                    if (end === undefined)
                        end = "...";

                    if (text.length <= length || text.length - end.length <= length) {
                        return text;
                    }
                    else {
                        return String(text).substring(0, length - end.length) + end;
                    }

                };
            })
            .filter('getNestedPropertyValue', GetNestedPropertyValueFilter)
            .filter('getRelativeDayBasedOnGivenDate', GetRelativeDayBasedOnGivenDateFilter)
            .constant('LoginBehaviourConst', {
                HOMEPAGE: 'HOMEPAGE',
                FAVORITE: 'FAVORITE',
                CLOSEST: 'CLOSEST'
            });

            angular.module("template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
                $templateCache.put("template/modal/backdrop.html",
                    "<div class=\"tvgmodal-backdrop\" modal-in-class=\"in\" modal-animation-class=\"fade\" ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"></div>");
            }]);

            angular.module("template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
                $templateCache.put("template/modal/window.html",
                    "<div tabindex=\"-1\" class=\"tvgmodal {{ windowClass }} fade\" modal-render=\"{{$isRendered}}\" modal-in-class=\"in\" modal-animation-class=\"fade\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" >\n" +
                    "	<div class=\"tvgmodal-dismiss no-click-feedback\" ng-click=\"windowClass=='confirm-bet'||windowClass=='first-time-help'||windowClass=='quick-deposit'||close($event)\"></div>\n" +
                    "   <div class=\"tvgmodal-dialog\"><div class=\"tvgmodal-content\" ng-transclude></div></div>\n" +
                    "</div>");
            }]);
    }
);

